import { sendGtmEvent } from "~/analytics/definitions";

const STRATEGY_MAPPING = {
  Default: 0,
  MoreLikeThis: 1,
  MoreLikeThisScann: 1,
  PureSearch: 2,
  AllowRankZero: 3,
  LongTailShortCircuit: 4,
  LongTailShortCircuitScann: 4,
  CompoundCorrection: 5,
  CompoundCorrectionScann: 5,
  DecompoundCorrection: 5,
  DecompoundCorrectionScann: 5,
  WordRemoval: 6,
  WordRemovalScann: 6,
  WordRemovalByRelevancy: 6,
  WordRemovalByRelevancyScann: 6,
  TerminalScann: 6,
  PureAlteredSearch: 7,
  MoreLikeThisAltered: 8,
  MoreLikeThisAlteredScann: 8,
} as const;

type StrategyKey = keyof typeof STRATEGY_MAPPING;

// There are a few defined cases when appliedSearchStrategies contains >1 tracked strategy,
// In these cases, we prioritize versions of MoreLikeThis.
// In all other cases, only one tracked strategy is expected to be present
const PRIORITY_OVERRIDES = [
  "MoreLikeThis",
  "MoreLikeThisAltered",
  "MoreLikeThisScann",
  "MoreLikeThisAlteredScann",
];

const mapStrategy = (strategies: string[]) => {
  if (!strategies || strategies.length === 0) {
    return 0;
  }

  let foundStrategy: StrategyKey = "Default";

  for (const strategy of strategies) {
    if (PRIORITY_OVERRIDES.includes(strategy)) {
      return STRATEGY_MAPPING[strategy as StrategyKey];
    }
    if (strategy in STRATEGY_MAPPING) {
      foundStrategy = strategy as StrategyKey;
    }
  }

  return STRATEGY_MAPPING[foundStrategy];
};

interface SendSearchABVariationGtmEventProps {
  appliedSearchStrategies: string[];
}

const sendSearchStrategyGtmEvent = ({
  appliedSearchStrategies,
}: SendSearchABVariationGtmEventProps) => {
  const strategyNumber = mapStrategy(appliedSearchStrategies);

  sendGtmEvent({
    event: "Search_Flow_Location",
    eventLabel: `Search_${strategyNumber}`,
  });
};

export default sendSearchStrategyGtmEvent;
